// extracted by mini-css-extract-plugin
export var content = "_di-3";
export var list = "_di-4";
export var settingsContent = "_di-7";
export var settingsPanel = "_di-8";
export var state = "_di-6";
export var triggerBadge = "_di-2";
export var triggerButton = "_di-1";
export var triggerShell = "_di-0";
export var unreadDot = "_di-5";